export type Attachment_Base = {
	scheme: string,
	name: string,
	content_type: string | null
}

export type Template = {
	locale: string,
	template_id: string,
	tone_of_voice: string,
	channel: string | null
}

export type Template_Attachment = Attachment_Base & {
	template: Template,
	data: string | null
}

export type Uri_Attachment = Attachment_Base & {
	uri: string
}

export type S3_Attachment = Attachment_Base & {
	bucket: string,
	key: string
}

export type Embedded_Attachment = Attachment_Base & {
	content: string
}

export type Attachment = Template_Attachment | Uri_Attachment | S3_Attachment | Embedded_Attachment

export const isTemplateAttachment = (attachment: any): attachment is Template_Attachment => attachment.scheme === 'template' || attachment.template;
export const isUriAttachment = (attachment: any): attachment is Uri_Attachment => attachment.scheme === 'uri' || attachment.uri;
export const isS3Attachment = (attachment: any): attachment is S3_Attachment => attachment.scheme === 's3' || attachment.bucket;
export const isEmbeddedAttachment = (attachment: any): attachment is Embedded_Attachment => attachment.scheme === 'embedded' || attachment.content;
